import { Component, OnInit, Input } from '@angular/core';
import { Category} from '../../products/product';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {


  @Input()
  categories: Category[];

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/home-page/breadcrumbs/breadcrumbs.component.ts